<template>
    <div class="affiliate">

        <h3 class="mb-3">My Affiliate Page</h3>

        <form class="d-flex flex-column" @submit.prevent="saveAffiliate">
            <div class="formp-group">
                <label>Affiliate Link</label>
                <div class="input-group mb-3">
                    <!-- <div class="input-group-prepend">
                        <span class="input-group-text">Your Affiliate Link:</span>
                    </div> -->
                    <input type="text" class="form-control" id="affiliate_link" v-model="customURL" readonly>
                    <div class="input-group-append">
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            v-clipboard:copy="customURL"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onCopyError"
                            v-b-popover.hover="'Copy to Clipboard'"
                        >
                            <font-awesome-icon :icon="['fad', 'clipboard']" />
                        </button>
                    </div>
                    <div class="input-group-append">
                        <a :href="customURL" class="btn btn-outline-secondary" v-b-popover.hover="'Open Affiliate Page'" target="_blank">
                            <font-awesome-icon :icon="['fad', 'browser']" />
                        </a>
                    </div>
                </div>
            </div>

            <!-- <div class='d-flex mb-3' v-if="!croppingPortrait">
                <div class='flex-grow-1 mr-3'>
                    <textarea v-model="affiliate.banner_comment" name="banner_comment" rows="8" class="form-control" />
                </div>
                <div class="portrait" :class="{'dropbox': !portraitURL}">
                    <form class="d-flex h-100 w-100" enctype="multipart/form-data" novalidate>

                        <img v-if="portraitURL" :src="portraitURL" width="100%" height="200">

                        <div class="overlay">
                            <font-awesome-icon :icon="['far', 'upload']" size="3x" class="align-self-center mx-auto" />
                        </div>

                        <div class="align-self-center mx-auto">
                            <font-awesome-icon v-if="!portraitURL" class="user-icon" :icon="['far', 'user']" size="5x" />
                            <input type="file" class="input-file" name='portrait' :disabled="portraitInProgress" @change="portraitChange($event.target.files)" accept="image/*">
                        </div>
                    </form>
                </div>
            </div>

            <div class="form-group">
                <label for="profileBanner">My Affilate Page Banner</label>
                <input ref="profileBanner" type="text" class="form-control" v-model="affiliate.profile_banner" />
            </div>

            <b-tabs content-class="my-3">
                <b-tab title="About Me" active>

                    <div class="form-group">
                        <label for="firstName">First Name</label>
                        <input ref="firstName" type="text" class="form-control" v-model="affiliate.first_name" />
                    </div>

                    <div class="form-group">
                        <label for="lastName">Last Name</label>
                        <input ref="lastName" type="text" class="form-control" v-model="affiliate.last_name" />
                    </div>

                    <div class="form-group">
                        <label for="currentSchool">Currently Working At</label>
                        <input ref="currentSchool" type="text" class="form-control" v-model="affiliate.current_school" />
                    </div>

                    <div class="form-group">
                        <label for="current_role">Role</label>
                        <input ref="current_role" name="current_role" type="text" class="form-control" formnovalidate v-model="affiliate.current_role" />
                    </div>

                    <div class="form-group">
                        <label for="city">City</label>
                        <input ref="city" type="text" class="form-control" v-model="affiliate.city" />
                        <div class="invalid-feedback">
                            City is required
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="state">State</label>
                        <select ref="state" type="text" class="form-control" v-model="affiliate.state">
                            <option v-for="(state, index) in states" :key="index" :value="state.state">
                                {{ state.fullState }}
                            </option>
                        </select>
                        <div class="invalid-feedback">
                            State is required
                        </div>
                    </div>
                </b-tab>
                <b-tab title="Posts">

                    <div class="mb-3">
                        <div v-for="(post, index) in affiliate.posts" :key="index" class="post card">
                            <div class="card-body">
                                <div class="d-flex">
                                    <div class="flex-grow-1 align-self-center">



                                        <div class="form-group">
                                            <label for="">Title</label>
                                            <input type="text" class="form-control" v-model="post.title">
                                        </div>

                                        <div class="form-group">
                                            <label for="">Body</label>
                                            <texarea type="text" class="form-control" v-model="post.body" />
                                        </div>


                                    </div>
                                    <div class="align-self-center ml-3">
                                        <a href="#" class="text-danger" @click.prevent="removePost(index)">
                                            <font-awesome-icon :icon="['fas', 'times']" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!affiliate.posts || affiliate.posts && !affiliate.posts.length" class="text-danger mb-3">
                        0 posts added
                    </div>

                    <button type="button" class="btn btn-sm btn-outline-primary" @click="addPost">
                        <font-awesome-icon :icon="['far', 'plus']" /> Add Post
                    </button>

                </b-tab>
                <b-tab title="Degrees">

                    <div class="mb-3">
                        <div v-for="(degree, index) in affiliate.degrees" :key="index" class="degree card">
                            <div class="card-body">
                                <div class="d-flex">
                                    <div class="flex-grow-1 align-self-center">
                                        <input type="hidden" v-model="degree.id" ref="id" />

                                        <div class="form-group">
                                            <label :for="'degree' + degree.id">Degree</label>
                                            <input :ref="'degree' + degree.id" type="text" class="form-control" v-model="degree.degree">
                                        </div>

                                        <div class="form-group mb-0">
                                            <label for="earned_from">Earned From</label>
                                            <input type="text" v-model="degree.earned_from" ref="earned_from" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="align-self-center ml-3">
                                        <a href="#" class="text-danger" @click.prevent="removeDegree(index)">
                                            <font-awesome-icon :icon="['fas', 'times']" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!affiliate.degrees || affiliate.degrees && !affiliate.degrees.length" class="text-danger mb-3">
                        0 degrees added
                    </div>

                    <button type="button" class="btn btn-sm btn-outline-primary" @click="addDegree">
                        <font-awesome-icon :icon="['far', 'plus']" /> Add Degree
                    </button>

                </b-tab>
                <b-tab title="Testimonials">

                    <div class="mb-3">
                        <div class="testimonial card" v-for="(testimonial, index) in affiliate.testimonials" :key="index">
                            <div class="card-body">
                                <div class="d-flex">
                                    <div class="flex-grow-1 align-self-center">
                                        <div class="form-group">
                                            <label :for="'testimonial_type' + index">Type</label>
                                            <select v-model="testimonial.testimonial_type" name="testimonial_type" type="text" class="form-control">
                                                <option v-for="(testimonialType, testimonialTypeIndex) in testimonialTypes" :key="testimonialTypeIndex" :value="testimonialType">
                                                    {{ testimonialType }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label :for="'testimonial' + index">
                                                Testimonial
                                            </label>
                                            <textarea :ref="'testimonial_comment' + index" class="form-control" v-model="testimonial.comment" />
                                        </div>
                                        <div class="form-group mb-0">
                                            <label :for="'by' + index">
                                                By
                                            </label>
                                            <input type="text" class="form-control" v-model="testimonial.by">
                                        </div>
                                    </div>
                                    <div class="align-self-center ml-3">
                                        <a href="#" class="text-danger" @click.prevent="removeTestimonial(index)">
                                            <font-awesome-icon :icon="['fas', 'times']" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!affiliate.testimonials || affiliate.testimonials && !affiliate.testimonials.length" class="text-danger mb-3">
                        0 testimonials added
                    </div>

                    <button type="button" class="btn btn-sm btn-outline-primary" @click="addTestimonial">
                        <font-awesome-icon :icon="['far', 'plus']" /> Add Testimonial
                    </button>

                </b-tab>
            </b-tabs>

            <div class="row">
                <div class="col-12">
                    <button class='btn btn-primary' @click.prevent="save" :disabled="savingAffiliatePage">
                        <div v-if="savingAffiliatePage">
                            <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
                        </div>
                        <div v-else>Save Changes</div>
                    </button>
                </div>
            </div> -->
        </form>
    </div>
</template>

<style lang="scss" scoped>
.preview {
    width: 400px;
    height: 400px;
    overflow: hidden;
}

.portrait {
    position: relative;
    cursor: pointer;
    width: 200px;
    height: 200px;

    & .overlay {
        background-color: rgba(0, 0, 0, .5);
        color: #FFFFFF;
        display: none;
    }

    & :hover .overlay {
        display: flex;
        position: absolute;
        width: 100%;
        height: 100%;
    }

    & .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 200px;
        height: 200px;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }
}

.dropbox {
    outline: 2px dashed #333333;

    background-color: #f5f5f5;

    & :hover {
        background-color: #f8f8f8;
        outline-color: #666666;
    }

    & .user-icon {
        color: #555555;
    }
    & :hover .user-icon {
        color: #777777;
    }
}

.degree + .degree,
.testimonial + .testimonial {
    margin-top: .25rem;
}
</style>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'





import states from '@/common/states'

export default {
    data: () => ({
        customURL: '',
        portraitURL: null,

        cropping: false,
        isPortraitEmpty: true,
        portraitInProgress: false,
        croppingPortrait: false,
        rawPortrait: null,
        savingPortrait: false,
        savingAffiliatePage: false,

        affiliateLoaded: false,
        affiliate: false,

        states: states,
        testimonialTypes: ["teacher", "student"],
    }),
    components: {
        VueCropper,
    },
    mounted () {
        this.portraitURL = this.$auth.user().portrait
        this.customURL = window.location.origin + "/t/" + this.$auth.user().linkCode,
        // get products on component mount
        this.getAffiliate()
    },
    methods: {
        addTestimonial () {

            if (
                !this.affiliate.testimonials ||
                this.affiliate.testimonials && !this.affiliate.testimonials.length
            ) {
                this.affiliate.testimonials = []
            }

            this.affiliate.testimonials.push({})

            // this.affiliate.testimonials.push({
            //     testimonial_type: "teacher",
            //     comment: "placeholder"
            // });
        },
        removeTestimonial (index) {
            this.affiliate.testimonials.splice(index, 1)
        },
        addPost () {
            if (
                !this.affiliate.posts ||
                this.affiliate.posts && !this.affiliate.posts.length
            ) {
                this.affiliate.posts = []
            }

            this.affiliate.posts.push({})
        },
        removePost (index) {
            this.affiliate.posts.splice(index, 1)
        },
        addDegree () {
            if (
                !this.affiliate.degrees ||
                this.affiliate.degrees && !this.affiliate.degrees.length
            ) {
                this.affiliate.degrees = []
            }

            this.affiliate.degrees.push({})

            // this.affiliate.degrees.push({
            //     earned_from: "University of Washington University", //@todo: Get non-satirical default values (uwu)
            //     degree: "Bachelor of Arts"
            // })
        },
        removeDegree (index) {
            this.affiliate.degrees.splice(index, 1)
        },
        getAffiliate () {
            this.affiliateLoaded = false

            this.$http({
                'url': 'dashboard/affiliate/get/' + this.$auth.user().id,
                'method': 'get'
            }).then((response) => {
                if (response.data.success) {
                    this.affiliate = response.data.affiliate

                    if (!this.affiliate.posts) {
                        this.$set(this.affiliate, "posts", [])
                    }

                    if( !this.affiliate.banner_comment) {
                        this.affiliate.banner_comment = 'Hi!  I thought you might be interested in Studies Weekly!  I use it every year to help teach my class both social studies and reading. If you look around the site, I\'m sure you\'ll find something you could use too.  The products are amazing, and are the most affordable I\'ve found as well.'
                    }

                    this.affiliateLoaded = true
                } else {
                    this.$swal({
                        text: response.data.message,
                        type: 'warning'
                    })
                }
            })
        },
        onCopy () {
            this.$swal({
                toast: true,
                html: 'Affiliate link copied',
                type: 'success',
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000
            })
        },
        onCopyError () {
            this.$swal({
                html: 'Link did not copy correctly. Please try again.',
                type: 'error'
            })
        },
        portraitChange (fileList) {
            if (fileList && fileList[0]) {
                this.portraitInProgress = true;
                let FR = new FileReader()
                let that = this
                FR.addEventListener("load", function(e) {
                    that.rawPortrait = e.target.result
                    that.croppingPortrait = true
                })
                FR.readAsDataURL(fileList[0])
            }
        },
        cancelPortraitChange () {
            this.portraitInProgress = false
            this.croppingPortrait = false
        },
        savePortrait (e) {
            let dataURL = this.$refs.cropper.getCroppedCanvas({width: 500, height: 500}).toDataURL()
            this.savingPortrait = true
            this.$http({
                'url': `dashboard/affiliate/savePortrait`,
                'method': 'POST',
                'data': {
                    'portrait': dataURL
                }
            }).then((response) => {
                if (response.data.success) {
                    this.portraitURL = response.data.url
                    this.$auth.fetch()
                } else {
                    this.$swal({
                        text: response.data.message,
                        type: 'warning'
                    })
                }
                this.savingPortrait = false
                this.croppingPortrait = false
                this.portraitInProgress = false
            }).catch(error => {
                this.$swal({
                    title: "Error",
                    text: error.message,
                    type: 'error'
                })
            })
        },
        save () {
            this.savingAffiliatePage = true

            this.$http({
                'url': 'dashboard/affiliate/save',
                'method': 'post',
                'data': {
                    'affiliate': this.affiliate
                }
            }).then((response) => {
                this.savingAffiliatePage = false

                this.$swal({
                    toast: true,
                    html: 'Changes saved',
                    type: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                })
            }).catch(error => {
                this.savingAffiliatePage = false

                this.$swal({
                    text: error.message,
                    type: 'error'
                })
            })
        }
    }
}
</script>
